import React, {useState} from "react"
import { StaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import ReactMarkdown from "react-markdown"
import cogoToast from 'cogo-toast';


let hasSent = false;
let validForm = true;
function checkInputs (){
    var serialize = require('form-serialize');
    let user = serialize(document.querySelector('#contactForm'), {hash:true}) ;
    console.log(JSON.stringify(user));
    console.log(user.name);
        if(!JSON.stringify(user.name)){
            validForm = false;
            document.getElementById('error-name').innerHTML = "* Campo obrigatório";
        }else{
            validForm = true;
            document.getElementById('error-name').innerHTML = "";
        }
   if(!JSON.stringify(user.email) ){
    validForm = false;
    document.getElementById('error-email').innerHTML = "* Campo obrigatório";
   }else if(!validateEmail(JSON.stringify(user.email))){
    validForm = false;
    document.getElementById('error-email').innerHTML = "* Por favor, insira um email válido."; 
   }else{
    validForm = true;
    document.getElementById('error-email').innerHTML = ""; 
   }

   if(!JSON.stringify(user.message)){
    validForm = false;
    document.getElementById('error-message').innerHTML = "* Campo obrigatório";
}else{
    validForm = true;
    document.getElementById('error-message').innerHTML = "";
}

 
    function validateEmail(email) {  
        const re= /\S+@\S+\.\S+/;
        return re.test(email);
    }

    return validForm;
}


let sendEmail =  async () => {
    if(hasSent){return;}
    hasSent=true; 
    var serialize = require('form-serialize');
    let user = serialize(document.querySelector('#contactForm'), {hash:true})
    let body = user;
    const rawResponse = fetch( "http://localhost:1337/contacts", { //set link progrm.
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body:JSON.stringify(body)
    }).then((response)=>
        {
                if(response.ok)
                {
                    cogoToast.success('Email enviado com sucesso!');
                    setTimeout(() =>{ window.location = '/'; }, 5);
                }
                else
                {
                    cogoToast.error('Email falhou no envio!');
                    hasSent = false;
                }
        }
    );


  };



const Contact = () =>{
    return (
    <Layout>
     <div>
     <style>{
    `#background{
      transform: rotate(46deg);
      bottom: -29%;
    }   
    @media only screen and (max-width: 450px) {
    #background{
        transform: rotate(-31deg);
        right: 25% !important;
        bottom: -15% !important;
    }

  }    
      
  }
  
    `}
  </style>
        <div className="infoTitle" style={{marginBottom:"2%"}}>Contacto</div>
         <div className="infoContact" style={{marginBottom:"2%"}}>Envie-nos a sua questão, iremos responder o mais breve possível.</div>
     <form id="contactForm" className="uk-width-1-2" style={{display:"inline-block"}}> 
                <input name="name" type="text" placeholder="Nome" autoComplete="off"></input>
                <span id="error-name"  style={{float:"left"}}></span>
                <input name="email" type="email" placeholder="Email" autoComplete="off" style={{marginTop:"20px"}}></input>
                <span id="error-email"  style={{float:"left"}}></span>
                <textarea name="message" placeholder="Mensagem" autoComplete="off" style={{marginTop:"20px"}}></textarea>
                <span id="error-message"  style={{float:"left"}}></span>
               <br/>
                <button className="submitButton" style={{cursor:"pointer"}} type="button"  onClick={() => {checkInputs(); if(validForm){sendEmail()}}}><span>ENVIAR</span></button>
            </form>
     </div>
        
    </Layout>)
    }
    
    export default Contact